export const ListQueryKey = 'teamSignRecords';
export const DetailQueryKey = 'teamSignRecord';

export const Urls = {
  selectUrl: '/groupSignRecord/list',
  updateUrl: '/groupSignRecord/update',
  deleteUrl: '/groupSignRecord/delete',
  createUrl: '/groupSignRecord/create',
  detailUrl: '/groupSignRecord/info',
};
